import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    exportContainer: {
      marginBottom: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',

      '& > *': {
        marginLeft: theme.spacing(2),
      },
    },
    subHeader: {
      width: '100%',
      backgroundColor: '#fff',
      padding: '0 24px',
    },
    noMarginTop: {
      marginTop: '0 !important',
    },
    noPaddingTop: {
      paddingTop: '0 !important',
    },
    noPadding: {
      padding: '0 !important',
    },
    tableData: {
      width: '100%',
      marginTop: 24,
      borderRadius: 4,
      backgroundColor: '#fff',
    },
    header: {
      display: 'flex',
      fontSize: 14,
      alignItems: 'center',
      padding: `${theme.spacing(2)}px 0`,
      borderBottom: '1px solid #e2e2e2',
      '& > div': {
        height: 'inherit',
      },
      '& .MuiGrid-container': {
        margin: 0,
        alignItems: 'center',
        height: 'inherit',
      },
      '& .MuiGrid-item': {
        padding: 0,
      },
    },
    titleHeader: {
      fontSize: 14,
    },
    table: {
      maxWidth: '100%',
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      fontSize: 14,
      '& .MuiContainer-root': {
        padding: 24,
        '& .MuiPaper-root': {
          boxShadow: 'unset',
          borderRadius: 0,
        },
      },
    },
    tableBody: {
      width: '100%',
      '& > tr:hover': {
        backgroundColor: 'rgb(125 125 125 / 0.02) !important',
      },
    },
    tableCell1: {
      width: '8.33%',
    },
    tableCell5: {
      width: '41.67%',
    },
    tableLegend: {
      textAlign: 'right',
      display: 'inline-flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      color: 'rgba(0, 0, 0, 0.45)',
      '& .MuiGrid-item': {
        fontSize: 14,
        display: 'flex',
      },
    },
    paginationContainer: {
      display: 'flex',
      alignItems: 'center',
      width: 'fit-content',
      marginLeft: 'auto',
      marginTop: theme.spacing(3),
    },
    paginationDataLabel: {
      fontSize: 14,
      color: theme.palette.secondary.main,
      fontWeight: 'bold',

      '& + p': {
        marginRight: theme.spacing(2),
      },
    },
    loadingContainer: {
      width: '100%',
      height: 250,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(2),
      position: 'absolute',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#fff',
      marginTop: theme.spacing(3),

      '& h2': {
        color: theme.palette.primary.light,
      },
    },
    icon: {
      fontSize: '5rem',
      color: theme.palette.primary.main,
    },
  }),
);
